import { BaseImage } from "../../../components/Content/BaseImage.tsx";
import { BaseClickableIcon } from "../../../components/Icon/BaseClickableIcon.tsx";
import { useAppMutation } from "../../../http/useAppMutation.ts";
import { useWorkspaceUuid } from "../../hooks/useWorkspaceUuid.ts";
import type { ModelImage } from "../../types.ts";

export const ModelCreationImageTile = ({
  image,
  modelUuid,
}: {
  image: ModelImage;
  modelUuid: string;
}) => {
  const workspaceUuid = useWorkspaceUuid();
  const deleteContent = useAppMutation({
    path: "contents/delete",
    invalidate: [
      `workspaces/${workspaceUuid}/references`,
      `references/${modelUuid}`,
    ],
  }).mutation;

  return (
    <div className="group relative rounded-100 overflow-hidden">
      <BaseClickableIcon
        name="Trash"
        className="absolute top-300 right-300 p-100 invisible group-hover:visible rounded-full border-025 bg-surface-primary-rest z-10"
        disabled={deleteContent.isLoading}
        onClick={(event) => {
          event.stopPropagation();
          deleteContent.mutate({
            uuids: [image.uuid],
          });
        }}
      />
      <BaseImage src={image.url} />
    </div>
  );
};
